import React, { useEffect, useRef, useState } from "react"
import { DialogInput } from "screens/components/advanced";
import Button from "screens/components/basic/Button";
import DialogHeaderWithClose from "screens/components/basic/DialogHeaderWithClose";
import { useParams } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import 'react-image-crop/dist/ReactCrop.css'
import { deleteProductGroupImagesAction, deleteProductImageAction, getProduct, getProductGroupImagesAction, getProductInfoAction, postNewProductImageAction, uploadProductGroupImagesAction } from "actions/EntityActions";
import { useDispatch, useSelector } from "react-redux";
import "./styles/ImageUploadingStyle.scss"
import SelectImageWithCrop from "screens/components/advanced/SelectImageWithCrop";
import CustomValueHook from "screens/components/advanced/customValueHook";


const ImageUploading = () => {
  const uploadSuccess = useSelector(state => state.entity.addProductGroupImagesSuccess)
  const uploadPending = useSelector(state => state.entity.addProductGroupImagesPending)
  const deleteSuccess = useSelector(state => state.entity.deleteProductGroupImagesSuccess)



  const branchId = useSelector(state => state.common.branchId)
  const productGroupImages = useSelector(state => state.entity.productGroupImages)
  const params = useParams();
  const [state, setState] = CustomValueHook({ displayModal: false, displayDeleteConfirmModal: false })
  const dispatch = useDispatch()


  useEffect(() => {
    if (state.displayModal) {
      dispatch(getProductGroupImagesAction(params.id))
    }

    if (uploadSuccess) {
      dispatch(getProductGroupImagesAction(params.id))
    }
    if (deleteSuccess) {
      setState({ displayDeleteConfirmModal: false, selectedImage: null })
      dispatch(getProductGroupImagesAction(params.id))

    }
  }, [state.displayModal, uploadSuccess, deleteSuccess])



  const handleUploadImage = async (imageBase64) => {

    dispatch(uploadProductGroupImagesAction({ ProductGroupId: params.id, Image: imageBase64 }));
  }
  const handleRemove = () => {
    dispatch(deleteProductGroupImagesAction({ ID: state.selectedImage.id }))
  }

  console.log("state.imageList", productGroupImages)


  return (
    <div className="main-product-group-image-uploading">
      <Button name="RaisedButton"
        className="pull-left"
        primary={true}
        onTouchTap={() => setState({ displayModal: true })}
        label="Upload Images" />

      <DialogInput
        title={<DialogHeaderWithClose text={"Upload product group image"} classicClass="posDialogClassic" handleClose={() => setState({ displayModal: false })} />}
        className="no_btns_dialog"
        modal={true}
        open={state.displayModal}
        autoScrollBodyContent={true}
        style={{ minWidth: "70% !important" }}
      >
        <div>
          <div>
            <div className="row" >
              <div className="col-md-5" >
                <SelectImageWithCrop
                  handleUpload={handleUploadImage}
                  uploadPending={uploadPending}
                  uploadSuccess={uploadSuccess}
                />
              </div>
              <div className="col-md-7" >
                <div className="product-group-image-modal-big-image-context" >
                  {!state.croppedImage ? <div>
                    {state.selectedImage ? <img src={state.selectedImage.imageUrl} /> : <div className="no-image-selected-context" ><h3>Not Image Selected</h3></div>}
                    {state.selectedImage && <span onClick={() => setState({ displayDeleteConfirmModal: true })}><DeleteIcon /></span>}
                  </div> : <div><img src={state.croppedImage} /></div>}
                </div>
                <div className="sm-images-context" >
                  <fieldset>
                    <legend>Uploaded Images</legend>
                    <div className="scroll-context" >
                      {productGroupImages  && productGroupImages.map((img, idx) =>
                        <div className="image-item" key={idx} onClick={() => setState({ selectedImage: img })}>

                          <img src={img.imageUrl} />
                        </div>)}
                      {(!productGroupImages || productGroupImages.length === 0) && <div className="mb-2">No images uploaded</div>}
                    </div>

                  </fieldset>
                </div>

              </div>

            </div>
          </div>
        </div>
      </DialogInput>

      <DialogInput
        title={<DialogHeaderWithClose text={"Upload product group image"} classicClass="posDialogClassic" handleClose={() => setState({ displayDeleteConfirmModal: false })} />}
        className="no_btns_dialog"
        modal={true}
        open={state.displayDeleteConfirmModal}
        autoScrollBodyContent={true}
        style={{ minWidth: "30% !important" }}
      >
        <div>
          <p>Are you sure you want to delete the image?</p>
        </div>
        <div>
          <Button
            className=" mr-2"
            type="IconInButton"
            label={"Confirm"}
            onTouchTap={handleRemove} />
          <Button
            type="IconInButton"
            className="bg-light-green"
            label={"Cancel"}
            dispatch={uploadPending}
            onTouchTap={() => setState({ displayDeleteConfirmModal: false })} />
        </div>
      </DialogInput>
    </div>
  )
}


export default ImageUploading
